import PropTypes from "prop-types";
import { Box } from "@mui/material";

const UnreadBadge = ({ count }) =>
  count > 0 ? (
    <Box
      component="span"
      sx={{
        minWidth: 22,
        height: 22,
        px: 0.75,
        borderRadius: 11,
        bgcolor: "error.main",
        color: "common.white",
        fontSize: "0.75rem",
        fontWeight: 700,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        boxShadow: "0 2px 6px rgba(244, 67, 54, 0.35)",
      }}
    >
      {count > 99 ? "99+" : count}
    </Box>
  ) : null;

UnreadBadge.propTypes = {
  count: PropTypes.number,
};

export default UnreadBadge;
